import { render } from "./WechatLogin.vue?vue&type=template&id=8fd1f378&scoped=true&ts=true"
import script from "./WechatLogin.vue?vue&type=script&lang=ts"
export * from "./WechatLogin.vue?vue&type=script&lang=ts"

import "./WechatLogin.vue?vue&type=style&index=0&id=8fd1f378&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd1f378"]])